// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LocationValidAddressModelResponse {
    static getAttributeTypeMap() {
        return LocationValidAddressModelResponse.attributeTypeMap;
    }
}
LocationValidAddressModelResponse.discriminator = undefined;
LocationValidAddressModelResponse.additionalProperties = false;
LocationValidAddressModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "LocationValidAddressResponseModel"
    },
];
//# sourceMappingURL=locationValidAddressModelResponse.js.map